import React, { Component } from 'react';
import Chart from 'react-google-charts';

import Box from '../ui/Box.js';
import Loading from '../ui/loading/Loading.js';
import ShowIff from '../ui/ShowIff.js';

import './summary.scss'

class Summary extends Component {
	calculateColours(crops) {
		let colours = [];
		for(let i=0; i < crops.length; i++) {
			colours.push(crops[i].Colour);
		}
		return colours;
	}
	render() {
		let data = [['Crop', 'Acres']];
		let acreage = 0;
		for(let i=0; i < this.props.crops.length; i++) {
			const a = parseFloat(this.props.crops[i].Acres);
			if (isNaN(a))
				break;
			data.push([this.props.crops[i].CropName, a]);
			acreage += parseFloat(a);
		}
		
		return (
			<Box className={"Farm Summary" + (this.props.discontinued ? " discontinued" : "")} title={this.props.FarmName} to={"farm/" + this.props.FarmID}>
				<ShowIff iff={this.props.discontinued}>
					<p className="discontinued">Discontinued on {this.props.DiscontinuedDate}</p>
				</ShowIff>
					
				<p className="summary">{acreage} acres ({Math.round(acreage/this.props.totalAcreage*100)}% of total acreage), split amongst {this.props.TotalFields} fields</p>
				<div className="chart-holder" onClick={(e)=>{e.preventDefault(); e.stopPropagation();}}>
					<Chart
						chartType="PieChart"
						width="100%"
						height="100%"
						loader={<Loading />}
						data={data}
						options={{
							backgroundColor: { fill:'transparent' },
							legend: {position: 'bottom'},
							chartArea: {width: '100%', height: '75%', left: '1em', top: '10%'},
							colors: this.calculateColours(this.props.crops),
						}}
					/>
				</div>
			</Box>
		);
	}
}

export default Summary;
